import { Node, mergeAttributes } from '@tiptap/core';
export const Concepts = Node.create({
    name: 'concepts',
    group: 'block',
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            boardUUIDs: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-concepts': attrs.boardUUIDs.join(',') };
                },
                parseHTML(element) {
                    const concepts = element.getAttribute('data-concepts');
                    return concepts?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setConcepts: (boardUUIDs) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: { boardUUIDs },
                });
            },
            showConceptsPicker: () => () => {
                this.options.showConceptPicker();
                return true;
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-concept',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-concept', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=concepts.js.map